<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_677)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6433 15.2653L12.7172 8.56957C12.6394 8.43693 12.568 8.31521 12.5015 8.20277C12.4351 8.31521 12.3636 8.43692 12.2859 8.56955L8.35938 15.2646C8.23027 15.4847 8.11202 15.6867 8.00404 15.8725C8.20538 15.7974 8.42442 15.715 8.66323 15.625L11.1758 14.6777C11.1968 14.6697 11.2203 14.6606 11.2462 14.6506C11.5002 14.5523 11.9762 14.368 12.498 14.3679C13.0197 14.3678 13.4959 14.5519 13.7499 14.6501C13.7757 14.6601 13.7992 14.6692 13.8203 14.6771L16.3395 15.6257C16.5782 15.7156 16.7971 15.7978 16.9983 15.8727C16.8904 15.6871 16.7723 15.4853 16.6433 15.2653ZM12.5016 5.71917C11.9288 5.71915 11.5446 6.37418 10.7763 7.68424L6.84984 14.3793C5.65769 16.412 5.06161 17.4284 5.51736 17.9689C5.9731 18.5095 7.07561 18.0938 9.28062 17.2625L11.7932 16.3151C12.1419 16.1837 12.3162 16.1179 12.4983 16.1179C12.6805 16.1179 12.8548 16.1835 13.2036 16.3148L13.2036 16.3148L15.7228 17.2635C17.9266 18.0933 19.0285 18.5083 19.4841 17.9678C19.9396 17.4273 19.344 16.4116 18.1529 14.3801L14.2268 7.68439C13.4586 6.37426 13.0745 5.7192 12.5016 5.71917Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_677">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
